export default __webpack_public_path__ + "static/media/click-logo.39d670bd.png";